// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","controls":"controls-3hILR","promoCode":"promoCode-2d9ty","additionalLinks_link":"additionalLinks_link-1bOl3","bottom":"bottom-2sx9s"};